import { Component, Output, EventEmitter, Input } from '@angular/core';
import { BaseToolComponent } from '../base-tool.component';
import { CanvasEvent } from 'src/app/events/canvas.event';
import { ContextData } from 'src/app/data/context.data';
import { LabelData } from 'src/app/data/configurator/label/label.data';
import { LayerData } from 'src/app/data/configurator/layer/layer.data';
import { HistoryData } from 'src/app/data/configurator/history.data';
import { ApplicationService } from 'src/app/services/application.service';
import { ApplicationData } from 'src/app/data/application.data';
import { ModalService } from 'src/app/services/modal.service';

@Component({
  selector: 'tools-bar',
  templateUrl: './tools-bar.component.html',
  host: {
    class: 'tools-bar'
  }
})
export class ToolsBarComponent extends BaseToolComponent {

  @Input() set command(event: CanvasEvent) {
    if (event) {
      this.processCommand(event);
    }
  }
  @Output() onCommand: EventEmitter<CanvasEvent> = new EventEmitter();

  @Input() set label(data: LabelData) {
    if ((this._labelData && this._labelData != data) || !this._labelData) {
      this.clearCurrentLabel();
      this._labelData = data;
      this.setLabel();
    }
  }
  get label(): LabelData {
    return this._labelData;
  }

  @Input() set layer(data: LayerData) {
    if (this._layerData != data) {
      this._layerData = data;
      this.setLayer();
    }
  }
  get layerData(): LayerData {
    return this._layerData;
  }

  public CanvasEvent = CanvasEvent;
  public ContextData = ContextData;
  public HistoryData = HistoryData;
  public LayerData = LayerData;

  public currentSheet = 0;

  /**
	 * Constructor
	 */
  constructor(
    private applicationService:ApplicationService,
    public applicationData: ApplicationData,
    private modalService: ModalService
    ) {
    super();
  }

	/**
	 * On init
	 */
  ngOnInit() {

  }

  /**
   * Send command
   */
  sendCommand(command: string): void {
    this.onCommand.emit(new CanvasEvent(command));
  }

  undo(): void {
    let command = HistoryData.undo();
    if (command) {
      this.applicationData.configuration.displayLabel(command.label);
      this.applicationService.currentLayerData = null
      if (command.layer) {
        setTimeout(() => {
          this.applicationService.currentLayerData = command.layer;
        }, 10);
      }
    }
  }

  /**
   * Preview sheets
   */
  previewSheets():void {
    this.modalService.open('modal-preview', {});
  }

	/**
	* On destroy
	*/
  ngOnDestroy() {

  }
}
